// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 175) return "static/chunks/175-6dbb9b6b6459694c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "e32da1e9d6c781ce" + ".js";
};